
// Types
import { DistanceInMilesProps } from './DistanceInMiles.types';

const DistanceInMiles = ({
  className,
  distanceInMiles,
}: DistanceInMilesProps) => {
  if (!distanceInMiles || distanceInMiles === 0) {
    return null;
  }

  return (
    <span className={className}>
      {`${distanceInMiles} miles`}
    </span>
  );
};

export default DistanceInMiles;
